module.exports = __webpack_public_path__ + "static/media/memory.b6cae1d9.svg";